{
  "version": 1,
  "asset_id": "c0e995a5-9f92-410d-b85c-9e395e4d1726",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/c0e995a5-9f92-410d-b85c-9e395e4d1726/sleeve-ugi-reflux-post-736.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/c0e995a5-9f92-410d-b85c-9e395e4d1726/sleeve-ugi-reflux-post-736.webp",
  "original_filename": "sleeve-ugi-reflux-post-736.webp",
  "size": 49894,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:38:37Z"
}
